import { render, staticRenderFns } from "./checkbox-dropdown-in-modal.vue?vue&type=template&id=538a38c0&scoped=true"
import script from "./checkbox-dropdown-in-modal.vue?vue&type=script&lang=js"
export * from "./checkbox-dropdown-in-modal.vue?vue&type=script&lang=js"
import style0 from "./checkbox-dropdown-in-modal.vue?vue&type=style&index=0&id=538a38c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a38c0",
  null
  
)

export default component.exports